/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React from "react";

// Catches any uncaught render error so the task pane shows a readable message
// instead of a blank white page (the failure mode reported on shared mailboxes).
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: "" };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message || "Unexpected error" };
    }

    componentDidCatch(error, info) {
        console.error("Add-in crashed:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: "16px", fontFamily: "Roboto, sans-serif" }}>
                    <p style={{ fontWeight: 600, marginBottom: "8px" }}>
                        Something went wrong loading the Axya add-in.
                    </p>
                    <p style={{ fontSize: "12px", color: "#666" }}>
                        This can happen in a shared or additional mailbox. Please reopen the
                        pane, and if it persists contact support.
                    </p>
                    <p style={{ fontSize: "11px", color: "#999", marginTop: "8px" }}>
                        {this.state.message}
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
